import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/society",
  name: "society",
  redirect: {
    name: "society",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "socialWorker",
      name: "socialWorker",
      meta: {
        title: "人才信息管理",
      },
      component: () => import("@/pages/society/socialWorker/index.vue"),
    },
    {
      path: "dynamic",
      name: "dynamic",
      meta: {
        title: "社工动态",
      },
      component: () => import("@/pages/society/dynamic/index.vue"),
    },
    {
      path: "organization",
      name: "organization",
      meta: {
        title: "社工机构",
      },
      component: () => import("@/pages/society/organization/index.vue"),
    },
    {
      path: "societyDemeanor",
      name: "societyDemeanor",
      meta: {
        title: "社会工作者风采",
      },
      component: () => import("@/pages/society/societyDemeanor/index.vue"),
    },
  ],
};
